<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div class="text-left">
              <CRow>
                <img
                  src="../../assets/img/icon/userprofile2.svg"
                  style="width: 15%"
                  class="float-left ml-5"
                  @click="OpenAnswerPopup()"
                />
                <CCol>
                  <CRow>
                    <div class="title mt-2 ml-4" style="color: #000a2c">
                      Gred A-
                    </div>
                    <div class="title mt-2 ml-5 custom-bg-result" style="color: #000a2c">
                      77%
                    </div></CRow
                  >

                  <div>
                    <label class="ml-3 sub-title-card text-black"
                      >7 of 12 correct</label
                    >
                  </div>
                  <div>
                    <label class="ml-3 sub-title-card text-black"
                      >(1hr 23 min)</label
                    >
                  </div>
                </CCol>
                <!-- <div class="title mt-2 mr-2" style="color: #000a2c">77%</div> -->
              </CRow>
            </div>
            <br />
            <div class="list-grade mt-4">
              <CRow class="ml-3">
                <CCol>
                  <div>
                    <span>
                      <span class="custom-user-title">Question 1</span><br />
                      <label class="custom-label-muted"
                        >Siapakah Sultan pertama Melaka?</label
                      >
                    </span>
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-answer"
                      >A. Parameswara</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-notanswer"
                      >B. Sultan Abu Bakar</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-notanswer"
                      >C. Sultan Abdullah</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label style="color: green">Correct</label
                    ><span>A. Parameswara</span>
                    <div style="clear: both"></div>
                  </div>
                </CCol>
              </CRow>
              <hr />
            </div>
            <div class="list-grade mt-4">
              <CRow class="ml-3">
                <CCol>
                  <div>
                    <span>
                      <span class="custom-user-title">Question 2</span><br />
                      <label class="custom-label-muted"
                        >Siapakah Sultan kedua Melaka?</label
                      >
                    </span>
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-notanswer"
                      >A. Parameswara</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-answer"
                      >B. Sultan Abu Bakar</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label class="custom-label-muted custom-bg-notanswer"
                      >C. Sultan Abdullah</label
                    >
                    <div style="clear: both"></div>
                  </div>
                  <div>
                    <label style="color: red">Incorrect</label
                    ><span>C. Sultan Abdullah</span>
                    <div style="clear: both"></div>
                  </div>
                </CCol>
              </CRow>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">My Result</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
    <CModal size="md" :show.sync="AnswerModal">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">Want to View Answer?</h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Let's subscribe to view your <br />
          quiz answer.
        </h4>
        <br />
      </div>
      <div class="text-center">
        <CButton class="btn-select-blue mt-5">Subscribe</CButton>
      </div>
      <div class="text-center">
        <CButton class="btn-select-white mt-2">Cancel</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DeactiveModal: false,
      AnswerModal: false,
    };
  },
  methods: {
    GoBack() {
      this.$router.back();
    },
    OpenAnswerPopup() {
      this.AnswerModal = true;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-btn-deactive {
  position: absolute;
  left: 0%;
  right: 0.61%;
  top: 0%;
  bottom: 0%;

  /* Body/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  color: #f85954;
}
.custom-text-deactive {
  position: absolute;
  width: 162px;
  height: 22px;
  left: 107px;
  top: 25px;

  /* Title/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  /* Black/Dark-001 */

  color: #000a2c;
}
.custom-bg-answer {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 12px;

  width: 139px;
  height: 37px;

  /* Blue/Light */

  background: #e8f4ff;
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.custom-bg-notanswer {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 12px;

  width: 166px;
  height: 37px;

  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.custom-bg-result{
    display: flex;
flex-direction: row;
align-items: flex-start;
padding: 8px 12px;

width: 74px;
height: 45px;

background: #D8FFD1;
border-radius: 8px;

/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}
</style>